import React, { useState, useEffect } from 'react';
import { Grid, Button, Typography, Select, MenuItem, InputLabel, FormControl, Box } from '@material-ui/core';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import FilterIcon from '@material-ui/icons/FilterList';
import { useSelector, useDispatch } from 'react-redux';
import { get, set, size } from 'global/lib/lodash';
import setFilter from 'redux/actions/setFilter';
import { TaskFilter } from 'global/utils/filter';
import { TaskStatus } from 'global/lib/filter';
import { useScreen } from 'global/styles';
import useStyles from 'global/styles/filters';
import FilterDivider from 'global/components/filter-divider';
import DiagContainer from 'global/components/diag-container';
import { setBodyOverflow } from 'global/hooks/useBodyOverflow';
import { OwnershipTask, TaskAge, TaskContent } from 'global/lib/filter';
import { sortAlphaNum } from 'global/utils';
import { FilterChips } from 'global/components/filterchips';

export default function PerformTasksFilters({ display, vendors }) {
  const [showFilters, setShowFilters] = useState(false);
  const filter = useSelector((state) => get(state, `filter.tasks.${display}`, TaskFilter()));
  const dispatch = useDispatch();
  const { ownership, status, content } = filter; // realm_type,

  const prefixToUse = 'vendor';

  const { isMobile } = useScreen();
  const useModalFilters = isMobile;

  const classes = useStyles({ isMobile: useModalFilters || isMobile });

  const isList = display === 'list' || display === 'realm';
  const showContentToggle = display === 'age';
  const isAge = display === 'age';

  useEffect(() => {
    setShowFilters(!useModalFilters);
  }, [useModalFilters]);

  const changeFilter = (filt) => {
    dispatch(setFilter('tasks', display, filt));
    setBodyOverflow();
  };

  const handleStatusChange = (e) => {
    changeFilter(set({ ...filter }, `status`, e.target.value));
  };

  const handleAgeChange = (e) => {
    changeFilter(set({ ...filter }, `age`, e.target.value));
  };

  const handleOwnership = (e, val) => {
    if (val !== null) {
      changeFilter(set({ ...filter }, `ownership`, val));
    }
  };

  const handleContent = (e, val) => {
    if (val !== null) {
      changeFilter(set({ ...filter }, `content`, val));
    }
  };

  const handleVendorChange = (e) => {
    const vend = get(vendors, 'data', []).find((v) => v.id == e.target.value);
    changeFilter(set({ ...filter }, `${prefixToUse}_id`, get(vend, `${prefixToUse}Id`, null)));
  };

  // const handleRealmType = (e, val) => {
  //   changeFilter(set({ ...filter }, `realm_type`, val));
  // }

  function toggleFilters() {
    setShowFilters(!showFilters);
  }

  const hasVendors = size(get(vendors, 'data')) > 0;
  const client = get(vendors, 'data', []).find((v) => get(v, [prefixToUse, 'id']) == get(filter, `${prefixToUse}_id`));

  return (
    <Box displayPrint="none">
      {useModalFilters && (
        <div className={classes.filterRow}>
          <Button className="FilterBtn" aria-label="filters" size="small" onClick={toggleFilters}>
            <FilterIcon fontSize="inherit" className={classes.icon} /> {showFilters ? 'Hide Filters' : 'Filters'}
          </Button>
          <FilterChips id={`tasks.${display}`} />
        </div>
      )}
      <DiagContainer useDialog={useModalFilters} onClose={toggleFilters} open={showFilters}>
        <Typography variant="overline">Filters</Typography>

        <form autoComplete="off" margin="normal" className={classes.form}>
          <Grid container alignContent="center">
            <Grid item xs={12}>
              <div className={classes.flexFilters}>
                <ToggleButtonGroup exclusive className={classes.btnGroup} size="small" value={ownership} onChange={handleOwnership}>
                  {OwnershipTask.map((t) => (
                    <ToggleButton value={t.value}>{t.title}</ToggleButton>
                  ))}
                </ToggleButtonGroup>

                {/* <ToggleButtonGroup className={classes.btnGroup} size="small" value={realm_type} onChange={handleRealmType}>
                  <ToggleButton title="Lot" value='lot'><HomeIcon /></ToggleButton>
                  <ToggleButton title="Community" value='community'><CommunityIcon /></ToggleButton>
                  <ToggleButton title="Division" value='division'><DivisionIcon /></ToggleButton>
                </ToggleButtonGroup> */}

                {showContentToggle && (
                  <div>
                    <FilterDivider />
                    <ToggleButtonGroup exclusive className={classes.btnGroup} size="small" value={content} onChange={handleContent}>
                      {TaskContent.map((t) => (
                        <ToggleButton value={t.value}>{t.title}</ToggleButton>
                      ))}
                    </ToggleButtonGroup>
                  </div>
                )}
              </div>
            </Grid>

            {isList && (
              <Grid item xs={12} className={classes.formGrid}>
                <FilterDivider />
                <FormControl variant="standard" className={classes.formItem}>
                  <InputLabel htmlFor="Standard-scorecard-simple">Status</InputLabel>
                  <Select value={status} onChange={handleStatusChange}>
                    {TaskStatus.map((ts, i) => (
                      <MenuItem key={i} value={ts.value}>
                        {ts.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            {isAge && (
              <Grid item xs={12} className={classes.formGrid}>
                <FormControl variant="standard" className={classes.formItem}>
                  <InputLabel htmlFor="Standard-scorecard-simple">Age</InputLabel>
                  <Select value={get(filter, 'age', null)} onChange={handleAgeChange}>
                    <MenuItem value={0}>
                      <em>Any</em>
                    </MenuItem>
                    {TaskAge.map((ts, i) => (
                      <MenuItem key={i} value={ts.value}>
                        {ts.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            {hasVendors && (
              <Grid item xs={12} className={classes.formGrid}>
                <FormControl variant="standard" className={classes.formItem}>
                  <InputLabel htmlFor="Standard-scorecard-simple">Company</InputLabel>
                  <Select value={get(client, 'id', 0)} onChange={handleVendorChange}>
                    <MenuItem value={0}>
                      <em>Any</em>
                    </MenuItem>
                    {get(vendors, 'data', [])
                      .sort((a, b) => sortAlphaNum(a, b, 'vendor.name'))
                      .map((vend, i) => (
                        <MenuItem key={`${vend.id}`} value={vend.id}>
                          {get(vend, [prefixToUse, 'name'], '')}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
          </Grid>
        </form>
      </DiagContainer>
    </Box>
  );
}
